import React from "react";
import { Box, Divider, Spacer, Stack } from "digiwash-components";
import Icon from "../Icon";

function SkeletonOrdersList() {
  let loadingOrderssrray = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
  return (
    <>
      <Divider size="l" />
      {loadingOrderssrray.map(() => {
        return (
          <>
            <Box p="m" bg="neutrals.250" br="l">
              <Box p="l" bg="common.white" br="xm">
                <Stack distribution="space-between">
                  <Box
                    bg="neutrals.250"
                    br="l"
                    style={{ width: 92, height: 16 }}
                  />
                  <Stack>
                    <Box
                      bg="neutrals.250"
                      br="l"
                      style={{ width: 92, height: 16 }}
                    />
                    <Spacer size="m" />
                    <Icon name="chevron-left" size={20} color="gray.lighter" />
                  </Stack>
                </Stack>
              </Box>
              <Stack distribution="center" p="l" direction="vertical">
                <Box
                  bg="common.white"
                  br="l"
                  style={{ width: 171, height: 24 }}
                />
                <Divider size="m" />
                <Box
                  bg="common.white"
                  br="l"
                  style={{ width: 288, height: 16 }}
                />
              </Stack>
            </Box>
            <Divider size="xl" />
          </>
        );
      })}
    </>
  );
}

export default SkeletonOrdersList;
